import { Dialog, Portal } from "@chakra-ui/react";
import { Button } from "@digital-services-gard-as/anchor-react";
import { t } from "i18next";
import { RefObject, useCallback } from "react";

type DeleteInvoiceModalProps = {
    invoiceId: string;
    isDeleteModalOpen: boolean;
    cancelRef: RefObject<HTMLButtonElement | null>;
    onCloseDeleteModal: () => void;
    deleteInvoice: (invoiceId: string) => void;
};

export const DeleteInvoiceModal = ({
    invoiceId,
    isDeleteModalOpen,
    cancelRef,
    onCloseDeleteModal,
    deleteInvoice
}: DeleteInvoiceModalProps) => {
    const handleDeleteClick = useCallback(() => {
        deleteInvoice(invoiceId);
        onCloseDeleteModal();
    }, [deleteInvoice, invoiceId, onCloseDeleteModal]);

    const handleOnOpenChange = useCallback(
        (e: { open: boolean }) => {
            if (!e.open) {
                onCloseDeleteModal();
            }
        },
        [onCloseDeleteModal]
    );

    const getInitialFocusEl = useCallback(() => cancelRef.current, [cancelRef]);
    return (
        <Dialog.Root
            open={isDeleteModalOpen}
            initialFocusEl={getInitialFocusEl}
            id="deleteInvoiceModal"
            role="alertdialog"
            onOpenChange={handleOnOpenChange}
        >
            <Portal>
                <Dialog.Backdrop>
                    <Dialog.Positioner>
                        <Dialog.Content data-testid="deleteInvoiceModal">
                            <Dialog.Header fontSize="lg" fontWeight="bold">
                                <Dialog.Title>{t("invoices:deleteInvoice")}</Dialog.Title>
                            </Dialog.Header>
                            <Dialog.Body>{t("invoices:createInvoice.deleteInvoiceMsg")}</Dialog.Body>
                            <Dialog.Footer>
                                <Button id="closeBtn" ref={cancelRef} onClick={onCloseDeleteModal} variant="secondary">
                                    {t("invoices:closeBtn")}
                                </Button>
                                <Button id="deleteBtn" variant="danger" onClick={handleDeleteClick}>
                                    {t("invoices:createInvoice.delete")}
                                </Button>
                            </Dialog.Footer>
                        </Dialog.Content>
                    </Dialog.Positioner>
                </Dialog.Backdrop>
            </Portal>
        </Dialog.Root>
    );
};
